var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoFullPrimary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 203 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.977 26.35H60.446V15.227h-3.572v25.826h3.572V29.759h14.531v11.294h3.572V15.228h-3.572V26.35zm26.133-11.475c-7.722 0-13.32 5.58-13.32 13.274 0 7.695 5.607 13.266 13.32 13.266s13.32-5.58 13.32-13.266-5.598-13.274-13.32-13.274zm6.863 20.373c-1.745 1.745-4.186 2.703-6.863 2.703-2.677 0-5.1-.958-6.854-2.703-1.781-1.782-2.758-4.304-2.758-7.099 0-2.794.977-5.326 2.758-7.098 1.745-1.745 4.177-2.704 6.854-2.704 2.677 0 5.118.959 6.863 2.704 1.782 1.772 2.767 4.295 2.767 7.098s-.985 5.317-2.767 7.099zm24.324 1.736l-9.404-21.757h-3.816l11.095 25.618.082.208h4.024l11.158-25.825h-3.716l-9.423 21.756zm23.963-7.244h13.283v-3.372H156.26v-7.75h15.662v-3.39h-19.225v25.825h19.378v-3.391H156.26V29.74zm37.96.254c3.238-.497 6.547-2.622 6.547-7.334 0-2.369-.805-4.222-2.396-5.515-1.574-1.275-3.834-1.918-6.728-1.918h-10.2v25.826h3.572V30.112h5.218l7.776 10.94h4.295l-8.084-11.058zm-9.205-3.183v-8.192h6.592c3.635 0 5.48 1.356 5.48 4.041 0 2.758-1.845 4.151-5.48 4.151h-6.592z",
    fill: "#333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.204 22v20.472l13.419-6.727V15.264L.203 22z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.797 20.59L23.677 0 6.914 8.419l20.12 20.59v20.48l16.764-8.418V20.59z",
    fill: "#3465A3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.323 47.735l-6.7-1.754V35.745l6.7 1.745v10.245z",
    fill: "#000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M.204 22v20.472l13.419-6.727V15.264L.203 22z",
    fill: "#3465A3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.797 20.59l-16.764 8.418-20.12-20.59L23.678 0l20.12 20.59zM20.323 47.735l-6.7-1.754V35.745l6.7 1.745v10.245z",
    fill: "#247DDC"
  })));
}

export default __webpack_public_path__ + "674975b22674b855451495b4dad1ddfe.svg";
export { SvgLogoFullPrimary as Component };